module.exports = false;


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1